import { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { Button, Col, Form, Row } from 'antd'
import { Formik } from 'formik'

import CustomInput from '../../components/CustomInput/customInput'
import CustomSelect from '../../components/CustomSelect/customSelect'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
import { isAdmin, isRtv } from '../../util/profiles'
import { ActionsPlanContext } from './ActionsPlan'

const ActionsPlanFilter = () => {
  const currentUser = useSelector((state) => state.auth.auth)
  const { filters, setFilters } = useContext(ActionsPlanContext)
  const [defaultFilters, setDefaultFilters] = useState({
    idRegion: filters.idRegion,
    idDistrict: filters.idDistrict
  })
  const [formData, setFormData] = useState({ customerName: '' })
  const [regions, setRegions] = useState([])
  const [districts, setDistricts] = useState([])

  useEffect(() => {
    fetchRegions({ active: true })
  }, [])

  useEffect(() => {
    if (regions.length) {
      const selectedRegion =
        defaultFilters.idRegion > 1 && regions.find((region) => region.value === defaultFilters.idRegion)
          ? defaultFilters.idRegion
          : regions.at().value
      onChangeRegion(selectedRegion)
      setFilters({ ...filters, idRegion: selectedRegion })
    }
  }, [regions])

  useEffect(() => {
    if (districts.length) {
      const selectedDistrict =
        defaultFilters.idDistrict > 1 && districts.find((district) => district.value === defaultFilters.idDistrict)
          ? defaultFilters.idDistrict
          : districts.at().value
      setFilters({ ...filters, idDistrict: selectedDistrict })
    }
  }, [districts])

  const handleFilter = () => {
    setFilters({
      ...filters,
      customerName: formData.customerName
    })
  }

  const clearFilters = () => {
    clearDefaultFilters()
    const idRegion = regions.at().value
    setFilters({
      ...filters,
      customerName: '',
      idRegion
    })
    setFormData({ customerName: '' })
    onChangeRegion(idRegion)
  }

  const clearDefaultFilters = () => {
    setDefaultFilters({})
  }

  async function onChangeRegion(regionId) {
    const districts = await request(api.getDistrictsDropdown({ regionId, active: true }))
    setDistricts(districts)
  }

  async function fetchRegions(params) {
    const regions = await request(api.getRegionsDropdown(params))
    setRegions(regions)
  }

  return (
    <div className="materials-filters">
      <Form layout="vertical">
        <Formik initialValues={{}} onSubmit={() => {}}>
          {({ errors, setFieldValue }) => {
            const setFieldValueWithState = (field, value) => {
              clearDefaultFilters()
              if (Object.keys(formData).includes(field)) {
                setFormData({ ...filters, [field]: value })
              } else {
                setFilters({ ...filters, [field]: value })
              }
              return setFieldValue(field, value)
            }
            return (
              <>
                <Row type="flex" justify="start">
                  <CustomSelect
                    field="idRegion"
                    enable={!isAdmin()}
                    label={getMessage('regions')}
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    onChange={onChangeRegion}
                    rowSpan={5}
                    value={filters}
                    values={regions}
                    required
                  />
                  <CustomSelect
                    showSearch
                    field="idDistrict"
                    enable={filters.idRegion < 1 || isRtv(currentUser)}
                    label={getMessage('districts')}
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={5}
                    value={filters}
                    values={districts}
                    required
                  />
                  <CustomInput
                    field="customerName"
                    labelInput={getMessage('customer')}
                    errors={errors}
                    setFieldValue={setFieldValueWithState}
                    rowSpan={6}
                    value={formData}
                  />
                  <Col span={4}>
                    <Button
                      icon="search"
                      className="bgPrimary"
                      type="dashed"
                      style={{ width: '100%', marginTop: 23 }}
                      onClick={handleFilter}
                    >
                      {getMessage('search')}
                    </Button>
                  </Col>
                  <Col span={4}>
                    <Button
                      icon="close"
                      style={{
                        width: '100%',
                        marginTop: 23,
                        borderColor: '#EE778F',
                        color: '#EE778F'
                      }}
                      type="ghost"
                      onClick={clearFilters}
                    >
                      {getMessage('cleanFilters')}
                    </Button>
                  </Col>
                </Row>
              </>
            )
          }}
        </Formik>
        <div className="horizontal-line" style={{ margin: '20px 0px 20px' }} />
      </Form>
    </div>
  )
}

export default ActionsPlanFilter
